import { FunctionComponent, useEffect, useState } from "react";
import styled from "styled-components";
import { useFormik } from "formik";
import { RatingConfig } from "constants/ratings";

type Props = {
  inputs: any[][];
  colNames: string[];
  rowNames: string[];
  onChange: (value: any) => any;
};

const cellWidth = `45px`;
const cellXGap = `2px;`;
const cellYGap = `8px`;

const StyledInputTable = styled.div`
  text-align: center;

  input[type="number"] {
    width: ${cellWidth};
    margin-right: ${cellXGap};
    padding: 8px;
  }
`;

const StyledColumnLabels = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${cellYGap};

  > div {
    width: ${cellWidth};
    margin-right: ${cellXGap};
  }
`;

const StyledRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${cellYGap};
`;
const StyledRowLabel = styled.div`
  width: ${cellWidth};
  margin-right: ${cellXGap};
`;

const InputTable: FunctionComponent<Props> = ({ inputs, colNames, rowNames, onChange }) => {
  const formik = useFormik({
    initialValues: {
      table: inputs,
    },
    onSubmit: (values) => {},
    validateOnChange: true,
    validate: (values) => {
      onChange(values.table);

      return {};
    },
  });

  const inputsId = inputs
    .flat()
    .map((i) => i)
    .join("-");

  useEffect(() => {
    formik.setValues({ table: inputs }, false);
  }, [inputsId]);

  const hasRowNames = rowNames && rowNames.length > 0;

  return (
    <form>
      <StyledInputTable>
        <StyledColumnLabels>
          {hasRowNames && <div style={{ opacity: 0 }}>Blank</div>}
          {colNames.map((name) => (
            <div>{name}</div>
          ))}
        </StyledColumnLabels>

        {inputs.map((_, i) => (
          <StyledRow>
            {hasRowNames && <StyledRowLabel>{rowNames[i]}</StyledRowLabel>}
            {inputs[i].map((_, j) => (
              <input
                name={`table[${i}][${j}]`}
                value={formik.values.table[i][j]}
                type="number"
                step={0.01}
                onChange={formik.handleChange}
              ></input>
            ))}
          </StyledRow>
        ))}
      </StyledInputTable>
    </form>
  );
};

export default InputTable;
